import Translate from './Translate'
import React from "react";

export default function LabelTradotta({
                                        htmlFor,
                                        children
                                      }) {

    return <label htmlFor={htmlFor} className="font-bold block mb-2"><Translate>{children}</Translate></label>;
}